import React from 'react';
import { Button } from '../components/ui/Button';
import { MetricCard } from '../components/MetricCard';
import { PerformanceChart } from '../components/PerformanceChart';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { ArrowLeft, Users, TrendingUp, Eye, Activity, Share2, MessageCircle, Heart, AlertCircle, Briefcase, CheckCircle2, Calendar, DollarSign, Clock, ListTodo } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { dates } from '../utils/dates';
export function CreatorDashboard() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  // Mock Data
  const followerData = [{
    name: 'Mon',
    value: 124000
  }, {
    name: 'Tue',
    value: 124200
  }, {
    name: 'Wed',
    value: 124500
  }, {
    name: 'Thu',
    value: 124800
  }, {
    name: 'Fri',
    value: 124900
  }, {
    name: 'Sat',
    value: 125000
  }, {
    name: 'Sun',
    value: 125200
  }];
  const engagementData = [{
    name: 'Mon',
    value: 3.8
  }, {
    name: 'Tue',
    value: 4.1
  }, {
    name: 'Wed',
    value: 3.9
  }, {
    name: 'Thu',
    value: 4.5
  }, {
    name: 'Fri',
    value: 4.2
  }, {
    name: 'Sat',
    value: 4.8
  }, {
    name: 'Sun',
    value: 4.6
  }];
  const recentPosts = [{
    id: 1,
    caption: 'Summer vibes ☀️ #travel #lifestyle',
    likes: 12400,
    comments: 342,
    engagement: '5.2%',
    date: '2 days ago',
    image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=800&auto=format&fit=crop&q=60'
  }, {
    id: 2,
    caption: 'New collaboration with @brand 🚀',
    likes: 8900,
    comments: 156,
    engagement: '3.8%',
    date: '4 days ago',
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&auto=format&fit=crop&q=60'
  }, {
    id: 3,
    caption: 'Morning routine ☕️',
    likes: 15600,
    comments: 420,
    engagement: '6.1%',
    date: '1 week ago',
    image: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=800&auto=format&fit=crop&q=60'
  }];
  const upcomingDeadlines = [{
    id: '1',
    title: 'Nike Instagram Post',
    date: dates.deliverableDeadline1,
    type: 'deliverable',
    urgent: true
  }, {
    id: '2',
    title: 'Nike Story Series',
    date: dates.deliverableDeadline2,
    type: 'deliverable',
    urgent: true
  }, {
    id: '3',
    title: 'Submit Nike Final Files',
    date: dates.taskDeadline1,
    type: 'task',
    urgent: false
  }];
  const activeCampaigns = [{
    id: '1',
    name: 'Nike Summer Campaign',
    brand: 'Nike',
    progress: 25,
    deadline: dates.activeDeadline1
  }, {
    id: '2',
    name: 'Adidas Fitness Series',
    brand: 'Adidas',
    progress: 0,
    deadline: dates.activeDeadline2
  }];
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-602">
      {/* Header */}
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-603">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-604">
          <div className="flex items-center" data-id="element-605">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/')} data-id="element-606">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-607" /> Back
            </Button>
            <div className="flex items-center space-x-3" data-id="element-608">
              <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-600 p-[2px]" data-id="element-609">
                <img src={user?.avatar || 'https://cdn.magicpatterns.com/uploads/5UvoNaV6trP2HazfDB17Dh/Bildschirmfoto_2026-01-20_um_11.23.35.png'} alt="Profile" className="h-full w-full rounded-full object-cover border-2 border-white" data-id="element-610" />
              </div>
              <span className="font-semibold text-gray-900" data-id="element-611">
                {user?.name || 'Yasmin Sunman'}
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-612">
            <Button variant="secondary" size="sm" data-id="element-613">
              <Share2 className="h-4 w-4 mr-2" data-id="element-614" /> Share Media Kit
            </Button>
            <Button variant="secondary" size="sm" onClick={() => navigate('/creator/campaigns')} data-id="element-615">
              My Campaigns
            </Button>
            <Button variant="gradient" size="sm" onClick={() => navigate('/creator/connect-api')} data-id="element-616">
              {user?.instagramConnected ? 'Settings' : 'Connect Brand'}
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-617">
        {!user?.instagramConnected && <div className="mb-8 bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-center justify-between shadow-sm" data-id="element-618">
            <div className="flex items-center space-x-3" data-id="element-619">
              <AlertCircle className="h-5 w-5 text-blue-600" data-id="element-620" />
              <div data-id="element-621">
                <h3 className="font-semibold text-blue-900" data-id="element-622">
                  Connect your Instagram account
                </h3>
                <p className="text-sm text-blue-700" data-id="element-623">
                  Connect your account to unlock real-time analytics and
                  insights for your campaigns.
                </p>
              </div>
            </div>
            <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={() => navigate('/creator/connect-api')} data-id="element-624">
              Connect Now
            </Button>
          </div>}

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8" data-id="element-625">
          <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate('/creator/campaigns')} data-id="element-626">
            <CardContent className="p-6 text-center" data-id="element-627">
              <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-628">
                <Briefcase className="h-6 w-6 text-blue-600" data-id="element-629" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-630">Campaigns</h3>
              <p className="text-sm text-gray-500" data-id="element-631">2 active</p>
            </CardContent>
          </Card>
          <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate('/creator/deliverables')} data-id="element-632">
            <CardContent className="p-6 text-center" data-id="element-633">
              <div className="h-12 w-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-634">
                <CheckCircle2 className="h-6 w-6 text-purple-600" data-id="element-635" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-636">Deliverables</h3>
              <p className="text-sm text-gray-500" data-id="element-637">6 pending</p>
            </CardContent>
          </Card>
          <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate('/creator/tasks')} data-id="element-638">
            <CardContent className="p-6 text-center" data-id="element-639">
              <div className="h-12 w-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-640">
                <ListTodo className="h-6 w-6 text-orange-600" data-id="element-641" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-642">Tasks</h3>
              <p className="text-sm text-gray-500" data-id="element-643">3 to do</p>
            </CardContent>
          </Card>
          <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate('/creator/brands')} data-id="element-644">
            <CardContent className="p-6 text-center" data-id="element-645">
              <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-646">
                <Users className="h-6 w-6 text-green-600" data-id="element-647" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-648">Brands</h3>
              <p className="text-sm text-gray-500" data-id="element-649">3 partners</p>
            </CardContent>
          </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8" data-id="element-650">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-2 space-y-8" data-id="element-651">
            <div className="mb-8" data-id="element-652">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-653">
                Dashboard Overview
              </h1>
              <p className="text-muted-foreground" data-id="element-654">
                Welcome back, {user?.name?.split(' ')[0] || 'Yasmin'}! Here's
                how your content is performing.
              </p>
            </div>

            {/* Metrics Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-655">
              <MetricCard title="Total Followers" value="125,200" trend={12} icon={<Users className="h-4 w-4 text-blue-500" data-id="element-657" />} data-id="element-656" />
              <MetricCard title="Engagement Rate" value="4.2%" trend={0.8} icon={<Activity className="h-4 w-4 text-pink-500" data-id="element-659" />} data-id="element-658" />
              <MetricCard title="Avg. Reach" value="45.5k" trend={-2.4} icon={<Eye className="h-4 w-4 text-purple-500" data-id="element-661" />} data-id="element-660" />
              <MetricCard title="Growth Rate" value="+1.2%" trend={5.4} trendLabel="vs last week" icon={<TrendingUp className="h-4 w-4 text-green-500" data-id="element-663" />} data-id="element-662" />
            </div>

            {/* Charts Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-664">
              <PerformanceChart title="Follower Growth (7 Days)" data={followerData} dataKey="value" color="#ec4899" type="line" data-id="element-665" />
              <PerformanceChart title="Engagement Trend" data={engagementData} dataKey="value" color="#8b5cf6" type="bar" data-id="element-666" />
            </div>

            {/* Recent Posts */}
            <Card data-id="element-667">
              <CardHeader data-id="element-668">
                <CardTitle data-id="element-669">Recent Posts Performance</CardTitle>
              </CardHeader>
              <CardContent data-id="element-670">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-671">
                  {recentPosts.map(post => <div key={post.id} className="group relative rounded-lg overflow-hidden border bg-white shadow-sm hover:shadow-md transition-all" data-id="element-672">
                      <div className="aspect-square w-full overflow-hidden bg-gray-100" data-id="element-673">
                        <img src={post.image} alt="Post thumbnail" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-674" />
                      </div>
                      <div className="p-4" data-id="element-675">
                        <div className="flex items-center justify-between text-sm text-gray-500 mb-2" data-id="element-676">
                          <span data-id="element-677">{post.date}</span>
                          <span className="font-medium text-pink-600" data-id="element-678">
                            {post.engagement} ER
                          </span>
                        </div>
                        <p className="text-sm font-medium text-gray-900 line-clamp-2 mb-4" data-id="element-679">
                          {post.caption}
                        </p>
                        <div className="flex items-center justify-between text-sm text-gray-600" data-id="element-680">
                          <div className="flex items-center" data-id="element-681">
                            <Heart className="h-4 w-4 mr-1" data-id="element-682" />{' '}
                            {post.likes.toLocaleString()}
                          </div>
                          <div className="flex items-center" data-id="element-683">
                            <MessageCircle className="h-4 w-4 mr-1" data-id="element-684" />{' '}
                            {post.comments}
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Right Column - Sidebar */}
          <div className="lg:col-span-1 space-y-6" data-id="element-685">
            {/* Upcoming Deadlines */}
            <Card data-id="element-686">
              <CardHeader data-id="element-687">
                <CardTitle className="text-base flex items-center" data-id="element-688">
                  <Clock className="h-4 w-4 mr-2" data-id="element-689" />
                  Upcoming Deadlines
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-690">
                <div className="space-y-3" data-id="element-691">
                  {upcomingDeadlines.map(deadline => {
                  const daysUntil = Math.ceil((new Date(deadline.date).getTime() - new Date().getTime()) / (1000 * 3600 * 24));
                  return <div key={deadline.id} className="flex items-start space-x-3 pb-3 border-b last:border-0" data-id="element-692">
                        <div className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${deadline.urgent ? 'bg-red-100' : 'bg-blue-100'}`} data-id="element-693">
                          <Calendar className={`h-4 w-4 ${deadline.urgent ? 'text-red-600' : 'text-blue-600'}`} data-id="element-694" />
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-695">
                          <p className="text-sm font-medium text-gray-900 truncate" data-id="element-696">
                            {deadline.title}
                          </p>
                          <p className={`text-xs ${deadline.urgent ? 'text-red-600 font-medium' : 'text-gray-500'}`} data-id="element-697">
                            {deadline.date} ({daysUntil}d left)
                          </p>
                          <Badge variant={deadline.type === 'deliverable' ? 'secondary' : 'default'} className="mt-1 text-xs" data-id="element-698">
                            {deadline.type}
                          </Badge>
                        </div>
                      </div>;
                })}
                </div>
                <Button variant="ghost" size="sm" className="w-full mt-4" onClick={() => navigate('/creator/tasks')} data-id="element-699">
                  View All Tasks
                </Button>
              </CardContent>
            </Card>

            {/* Active Campaigns */}
            <Card data-id="element-700">
              <CardHeader data-id="element-701">
                <CardTitle className="text-base flex items-center" data-id="element-702">
                  <Briefcase className="h-4 w-4 mr-2" data-id="element-703" />
                  Active Campaigns
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-704">
                <div className="space-y-4" data-id="element-705">
                  {activeCampaigns.map(campaign => <div key={campaign.id} className="pb-4 border-b last:border-0" data-id="element-706">
                      <div className="flex items-start justify-between mb-2" data-id="element-707">
                        <div data-id="element-708">
                          <p className="text-sm font-medium text-gray-900" data-id="element-709">
                            {campaign.name}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-710">
                            {campaign.brand}
                          </p>
                        </div>
                        <Badge variant="default" className="text-xs" data-id="element-711">
                          {campaign.progress}%
                        </Badge>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-712">
                        <div className="bg-blue-600 h-2 rounded-full transition-all" style={{
                      width: `${campaign.progress}%`
                    }} data-id="element-713" />
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-714">
                        Due: {campaign.deadline}
                      </p>
                    </div>)}
                </div>
                <Button variant="ghost" size="sm" className="w-full mt-4" onClick={() => navigate('/creator/campaigns')} data-id="element-715">
                  View All Campaigns
                </Button>
              </CardContent>
            </Card>

            {/* Earnings Summary */}
            <Card data-id="element-716">
              <CardHeader data-id="element-717">
                <CardTitle className="text-base flex items-center" data-id="element-718">
                  <DollarSign className="h-4 w-4 mr-2" data-id="element-719" />
                  Earnings Summary
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-720">
                <div className="space-y-3" data-id="element-721">
                  <div className="flex items-center justify-between" data-id="element-722">
                    <span className="text-sm text-gray-600" data-id="element-723">This Month</span>
                    <span className="text-lg font-bold text-gray-900" data-id="element-724">
                      €8,000
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-725">
                    <span className="text-sm text-gray-600" data-id="element-726">Pending</span>
                    <span className="text-sm font-medium text-yellow-600" data-id="element-727">
                      €5,000
                    </span>
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t" data-id="element-728">
                    <span className="text-sm text-gray-600" data-id="element-729">Total (2025)</span>
                    <span className="text-lg font-bold text-green-600" data-id="element-730">
                      €16,000
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
    </div>;
}